<div class="banner" *ngIf="showBanner" [@slideInOut]="'in'">
	<img *ngIf="image" class="left-icon" [src]="image | resolveAsset" alt="No Audio" />
	<p class="message">{{ message }}</p>
	<button *ngIf="buttonText" (click)="callBack()">{{ buttonText }}</button>
</div>
